<template>
  <div class="pa-4 pa-md-5">
    <!-- Botón Volver -->
    <v-btn @click="$router.back()" class="back-btn mb-3">
      <v-icon left>mdi-arrow-left</v-icon>
      VOLVER
    </v-btn>

    <!-- Card de Filtros -->
    <v-card class="rounded-lg elevation-3 overflow-hidden mb-4">
      <v-toolbar height="54" color="secondary" dark flat class="px-3 px-md-4">
        <v-icon left>mdi-filter-variant</v-icon>
        <span class="text-h6 font-weight-medium"> Filtros de Búsqueda </span>
        <v-chip
          v-if="Filtro.indicador"
          small
          color="white"
          text-color="secondary"
          class="font-weight-bold ml-3 px-3 elevation-1"
          style="font-size: 0.9rem; height: 28px"
        >
          <v-icon left size="16" color="secondary">mdi-chart-line</v-icon>
          {{ Filtro.indicador }} - {{ Filtro.anio }}
        </v-chip>
      </v-toolbar>

      <v-card-text class="pa-4 pa-md-5">
        <v-row dense align="center">
          <v-col cols="12" sm="6" md="6">
            <v-autocomplete
              :items="ArrayIndicador"
              v-model="Filtro.indicador"
              @change="ActualizarTabla"
              label="Seleccionar Indicador"
              placeholder="Seleccionar tipo de indicador..."
              outlined
              dense
              hide-details
              prepend-inner-icon="mdi-chart-line"
              class="rounded-lg"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="6" md="6">
            <v-autocomplete
              :items="ArrayAños"
              v-model="Filtro.anio"
              @change="ActualizarTabla"
              label="Seleccionar Año"
              placeholder="Seleccionar año..."
              outlined
              dense
              hide-details
              prepend-inner-icon="mdi-calendar"
              class="rounded-lg"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Contenedor Principal de la Tabla -->
    <v-col cols="12" class="pa-0">
      <tabla
        Titulo="Criterios de Aceptación"
        :Cabecera="Cabecera"
        :Items="Items"
        :Excel="true"
        :Crear="true"
        :Filtro="Filtro"
        :Loading="Loading"
      />
    </v-col>
  </div>
</template>

<script>
import tabla from "@/components/criterioaceptacion/tabla.vue";

import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "Criterio_Aceptacion",
  components: {
    tabla,
  },
  async created() {
    this.cargarAnios();
    await this.cargarCriterioAceptacion();
    this.Filtro = {
      indicador: this.Indicador,
      anio: this.Año,
    };
  },
  data() {
    return {
      Cabecera: [
        {
          text: "Acciones",
          value: "acciones",
          align: "center",
          sortable: false,
          width: 90,
        },
        {
          text: "ID",
          value: "id",
          align: "center",
          width: 50,
        },
        {
          text: "Modelo",
          value: "modelo",
          align: "left",
        },
        {
          text: "Medida",
          value: "medida",
          align: "left",
        },
        {
          text: "C. Superior (Obj.)",
          value: "criterio_superior",
          align: "center",
          cellClass: "col-criterio-superior",
          class: "th-criterio-superior",
          width: 160,
        },
        {
          text: "Tolerable Máx.",
          value: "rango_c_superior",
          align: "center",
          cellClass: "col-tolerable-max",
          class: "th-tolerable-max",
          width: 160,
        },
        {
          text: "Tolerable Mín.",
          value: "rango_c_inferior",
          align: "center",
          cellClass: "col-tolerable-min",
          class: "th-tolerable-min",
          width: 160,
        },
        {
          text: "C. Inferior (Def.)",
          value: "criterio_inferior",
          align: "center",
          cellClass: "col-criterio-inferior",
          class: "th-criterio-inferior",
          width: 160,
        },
        {
          text: "Rango de Aceptación",
          value: "criterioaceptacion",
          align: "center",
          width: 160,
        },
      ],
      ArrayIndicador: [
        "Costo por kilómetro",
        "Costo por hora",
        "Índice de reencauche",
        "Índice de reencauchabilidad",
      ],
      ArrayAños: [],
      Filtro: {},
    };
  },
  methods: {
    ...mapActions("criterioaceptacion", [
      "cargarCriterioAceptacion",
      "CambioSelect",
    ]),

    ActualizarTabla() {
      this.CambioSelect(this.Filtro).then(() => {
        this.cargarCriterioAceptacion();
      });
    },
    cargarAnios() {
      const fecha = new Date();
      let anio_inicio = 2017;
      let anio_final = fecha.getFullYear() + 2;

      for (let i = anio_inicio; i <= anio_final; i++) {
        this.ArrayAños.push(i);
      }
      this.$forceUpdate();
    },
  },
  computed: {
    ...mapGetters("criterioaceptacion", ["Items", "Año", "Indicador"]),
    ...mapState("criterioaceptacion", ["Loading"]),
  },
};
</script>
